import React from 'react'
import PropTypes from 'prop-types'

import { Container, Alert } from '@sainsburys-tech/fable'

import SignOutButton from '../Buttons/SignOutButton'
import api from '../../utils/api'
import logger from '../../utils/logger'
import LoadingOverlay from '../LoadingOverlay'
import signOut from '../../utils/signOutHelper'

class SignOut extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      siteName: undefined,
      loading: false,
      signOutError: null
    }
  }

  componentDidMount() {
    const { setHeader, setSignOutHeader } = this.props
    setHeader()
    setSignOutHeader(false)
    this.getSiteName()
  }

  signOutStatus = () => {
    const { signOutError } = this.state
    if (signOutError) {
      return (
        <div className="dsib-signOut__error">
          <Alert status="error" isOpen message={signOutError} />
        </div>
      )
    }
    return ''
  }

  getSiteName = async () => {
    const { user } = this.props
    await api.getSiteName(user.userName)
      .then((res) => {
        this.setState({
          siteName: res,
          loading: false
        })
      })
      .catch((e) => {
        logger.logError(e)
        this.setState({ signOutError: 'You are not signed in' })
      })
  }

  performSignOut = () => {
    const { deviceType, contractor, signedOutSiteType } = this.props

    this.setState({ loading: true })
    signOut(deviceType, contractor, signedOutSiteType, this.signOutCallback)
  }

  signOutCallback = (response) => {
    const { history } = this.props

    if (response.isError) {
      if (!response.currentlySignedIn) {
        this.setState({ signOutError: 'You are not currently signed in', loading: false })
        setTimeout(() => {
          history.push('/signin')
        }, 3000)
      } else {
        this.setState({ signOutError: response.error, loading: false })
      }
    } else {
      history.push({
        pathname: '/confirmation',
        state: { signIn: false }
      })
    }
  }

  render() {
    const { loading, siteName } = this.state

    return (
      <div className="dsib-signOut u-no-scroll__vertical">
        <Container size="xl">
          <div className="dsib-signOut__grid">
            <div className="dsib-signOut__center">
              {loading ? <LoadingOverlay text="Signing you out" /> : <SignOutButton onClick={this.performSignOut} />}

              {loading === false && (
                <div className="dsib-signOut__siteName">{siteName}</div>
              )}

              {this.signOutStatus()}
            </div>
          </div>
        </Container>
      </div>
    )
  }
}

SignOut.propTypes = {
  setHeader: PropTypes.func.isRequired,
  setSignOutHeader: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  user: PropTypes.shape({
    userName: PropTypes.string.isRequired
  }).isRequired,
  contractor: PropTypes.shape({
    username: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired
  }).isRequired,
  deviceType: PropTypes.number.isRequired,
  signedOutSiteType: PropTypes.string.isRequired
}

export default SignOut
